/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { Component } from 'react';
import { IFair } from '@umati/dashboard-types';
import { ReactSVG } from 'react-svg';
import URLs from '../../utilities/URLs';
import { ErrorBoundary } from '@umati/dashboard-common';

interface IFairMapProps {
  fair?: IFair;
  locationHall: string;
  filterCallback?: (id : string) => void;
}

class FairMap extends Component<IFairMapProps> {
  private refFairMap : any;
  constructor (props) {
    super(props);
    this.hallClickCallback = this.hallClickCallback.bind(this);
    this.hallChangedCallback = this.hallChangedCallback.bind(this);
    this.setupInnerSvgMap = this.setupInnerSvgMap.bind(this);
    this.setActiveHall = this.setActiveHall.bind(this);
    this.refFairMap = React.createRef();
  }

  hallClickCallback (event) {
    const document = event.target.ownerDocument;
    const id = event.target.id;
    this.hallChangedCallback(document, id);
  }

  hallSetActive (baseVal) {
    return baseVal + ' active';
  }

  hallSetInactive (baseVal) {
    return baseVal.replace('active', '');
  }

  hallChangedCallback (document, id) {
    if ('getElementById' in document) {
      const element = document.getElementById(id);
      if (this.props.fair && element) {
        const baseVal = element.className.baseVal;
        if (this.props.fair.Halls?.includes(id)) {
          if (baseVal.includes('active')) {
            this.props.filterCallback?.('all');
            this.setActiveHall(element, 'all');
          } else {
            this.props.filterCallback?.(id);
            this.setActiveHall(element, id);
          }
        }
      }
    }
  }

  setActiveHall (element, locationHall) {
    const halls = this.props.fair?.Halls || [];
    for (const hall of halls) {
      const passiveElement: any = document.getElementById(hall);
      if (passiveElement?.className?.baseVal) {
        passiveElement.className.baseVal = this.hallSetInactive(passiveElement.className.baseVal);
      }
    }

    if (this.props.fair && element) {
      const baseVal = element.className.baseVal;
      if (halls.includes(locationHall)) {
        if (baseVal.includes('active')) {
          element.className.baseVal = this.hallSetInactive(baseVal);
        } else {
          element.className.baseVal = this.hallSetActive(baseVal);
        }
      }
    }
  }

  setupInnerSvgMap () {
    /* HACK: Needed because the hall elements in the map svg inside of ReactSvg are mounted after the parent element */
    let retries = 0;
    const scroll = () => {
      const element = document.getElementById(this.props.locationHall);
      if (retries >= 200 || element) {
        this.setActiveHall(element, this.props.locationHall);
        return;
      } else {
        setTimeout(scroll, 200);
      }
      retries = retries + 1;
    };
    scroll();
  }

  componentDidMount(): void {
    this.setupInnerSvgMap(); 
  }

  render () {
    const element: any = document.getElementById(this.props.locationHall);
    this.setActiveHall(element, this.props.locationHall);

    return (
      <div className="fair-map">
        <ErrorBoundary title="test">
        { this.props.fair?.Tag && <ReactSVG src={URLs.getFairMapBucket(this.props.fair?.Tag)} ref={this.refFairMap} onClick={this.hallClickCallback}></ReactSVG> }
        </ErrorBoundary>
      </div>
    );
  }
}

export default FairMap;
